import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import PropertyCard from "@/components/PropertyCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Vendita() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/properties?tipo=vendita`)
      .then((res) => setProperties(res.data))
      .catch(() => setProperties([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <section className="bg-white py-24 md:py-32 px-6" data-testid="vendita-page">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
            <div>
              <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block mb-2">
                In Evidenza
              </span>
              <h1 className="font-display text-[clamp(32px,3.8vw,52px)] font-bold leading-tight">
                Immobili in Vendita
              </h1>
            </div>
            <span className="font-mono-lbl text-xs text-[var(--ink)]/70 uppercase">
              Incarichi in esclusiva verificati
            </span>
          </div>

          {loading ? (
            <p className="font-mono-lbl text-xs uppercase text-[var(--ink)]/50" data-testid="vendita-loading">
              Caricamento immobili...
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="vendita-grid">
              {properties.map((p) => (
                <PropertyCard key={p.id} property={p} />
              ))}
            </div>
          )}
          <p className="mt-6 font-mono-lbl text-[10px] uppercase tracking-wider text-[var(--ink)]/40">
            Annunci reali pubblicati dall'agenzia · Modena e provincia
          </p>
        </div>
      </section>

      <section className="bg-[var(--ink)] text-white py-20 px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-light)] block mb-2">
              Vuoi vendere?
            </span>
            <h2 className="font-display font-bold text-2xl md:text-3xl leading-tight">
              Scopri prima quanto vale il tuo immobile.
            </h2>
          </div>
          <Link
            to="/calcolatore"
            data-testid="vendita-cta-calcolatore"
            className="px-8 py-4 bg-[var(--gold)] text-[var(--ink)] font-mono-lbl text-xs uppercase tracking-widest font-bold rounded hover:bg-white transition-colors"
          >
            Apri il Calcolatore →
          </Link>
        </div>
      </section>
    </>
  );
}
